import { render, staticRenderFns } from "./QuestionItem.vue?vue&type=template&id=b9c9733e&scoped=true&"
import script from "./QuestionItem.vue?vue&type=script&lang=js&"
export * from "./QuestionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c9733e",
  null
  
)

export default component.exports